var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFutures = function SvgFutures(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.59 16.125a4.375 4.375 0 0 1-4.374 4.375H7.24V3h14.35zM11.03 7.7v4.958l.011.157c.07 1.537 1.501 2.905 3.2 2.985h.18c1.823 0 3.311-1.381 3.38-2.997V7.7h-1.72v4.944c0 .829-.746 1.537-1.66 1.537-.926 0-1.671-.708-1.671-1.537V7.7zM5.796 10.797H2v5.906C2 18.8 3.7 20.5 5.796 20.5z"
  })));
};
export default SvgFutures;